import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TrendingFacebookInfluencers.graphql';
import { Query, QuerytrendingFacebookInfluencersArgs } from '../../__generated__/globalTypes';

export const useTrendingFacebookInfluencersQuery = (
  options?: QueryHookOptions<Query, QuerytrendingFacebookInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytrendingFacebookInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTrendingFacebookInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytrendingFacebookInfluencersArgs>
): QueryResult<Query, QuerytrendingFacebookInfluencersArgs> & {
  getTrendingFacebookInfluencers: LazyQueryExecFunction<Query, QuerytrendingFacebookInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTrendingFacebookInfluencers, result] = useLazyQuery<Query, QuerytrendingFacebookInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTrendingFacebookInfluencers, ...result };
};

export const useTrendingFacebookInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getTrendingFacebookInfluencers = useCallback(
    (options?: Omit<QueryOptions<QuerytrendingFacebookInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QuerytrendingFacebookInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTrendingFacebookInfluencers };
};
// Suspense Query Hooks
export const useTrendingFacebookInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytrendingFacebookInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytrendingFacebookInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
